const base = {
  web_sale: process.env.NODE_ENV === "development" ? "/web_sale" : "https://sale.58jl.net/web_sale"
};
export default base;